(() => {
  const initialiseDirectory = (root = document) => {
    root.querySelectorAll('.pm-directory-description-toggle').forEach((button) => {
      if (button.dataset.pmInitialised === 'true') {
        button.pmRefresh?.();
        return;
      }

      const description = document.getElementById(button.getAttribute('aria-controls'));
      if (!description) return;

      const refresh = () => {
        if (button.getAttribute('aria-expanded') === 'true') return;
        description.classList.remove('is-clamped');
        const fullHeight = description.scrollHeight;
        const lineHeight = Number.parseFloat(window.getComputedStyle(description).lineHeight);
        const collapsedHeight = Number.isFinite(lineHeight) ? lineHeight * 3 : description.clientHeight;
        description.classList.add('is-clamped');
        button.hidden = fullHeight <= collapsedHeight + 2;
      };

      button.addEventListener('click', () => {
        const willExpand = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(willExpand));
        description.classList.toggle('is-clamped', !willExpand);
        button.textContent = willExpand ? button.dataset.readLess : button.dataset.readMore;
      });

      button.dataset.pmInitialised = 'true';
      button.pmRefresh = refresh;
      description.classList.add('is-clamped');
      requestAnimationFrame(refresh);
    });
  };

  const initialiseCategoryBrowsers = (root = document) => {
    root.querySelectorAll('[data-pm-category-browser]').forEach((browser) => {
      if (browser.dataset.pmCategoryInitialised === 'true') {
        browser.pmCategoryRefresh?.();
        return;
      }

      const buttons = Array.from(browser.querySelectorAll('[data-pm-category-tab]'));
      const panels = Array.from(browser.querySelectorAll('[data-pm-category-panel]'));
      if (!buttons.length || buttons.length !== panels.length) return;

      const desktop = window.matchMedia('(min-width: 990px)');
      let activeIndex = Number.parseInt(browser.dataset.activeIndex || '0', 10);
      if (!Number.isInteger(activeIndex) || activeIndex < 0 || activeIndex >= buttons.length) activeIndex = 0;

      const refresh = () => {
        const isDesktop = desktop.matches;
        buttons.forEach((button, index) => {
          const isActive = index === activeIndex;
          button.setAttribute('aria-selected', String(isActive));
          button.setAttribute('tabindex', isActive ? '0' : '-1');
          button.closest('.pm-catalogue-l1-nav-item')?.classList.toggle('is-active', isActive);
        });
        panels.forEach((panel, index) => {
          panel.hidden = isDesktop && index !== activeIndex;
          if (isDesktop && index === activeIndex) {
            const disclosure = panel.querySelector('.pm-catalogue-group');
            if (disclosure) disclosure.open = true;
          }
        });
      };

      const activate = (index, moveFocus = false) => {
        activeIndex = (index + buttons.length) % buttons.length;
        browser.dataset.activeIndex = String(activeIndex);
        refresh();
        if (moveFocus) buttons[activeIndex].focus();
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', (event) => {
          let nextIndex;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = index + 1;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = index - 1;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = buttons.length - 1;
          else return;
          event.preventDefault();
          activate(nextIndex, true);
        });
      });

      browser.querySelectorAll('.pm-catalogue-children--l2').forEach((disclosure) => {
        disclosure.addEventListener('toggle', () => {
          if (desktop.matches || !disclosure.open) return;

          const catalogueGrid = disclosure.closest('.pm-catalogue-grid');
          if (!catalogueGrid) return;

          catalogueGrid.querySelectorAll('.pm-catalogue-children--l2[open]').forEach((sibling) => {
            if (sibling !== disclosure) sibling.open = false;
          });
        });
      });

      if (desktop.addEventListener) desktop.addEventListener('change', refresh);
      else desktop.addListener(refresh);

      browser.dataset.pmCategoryInitialised = 'true';
      browser.pmCategoryRefresh = refresh;
      refresh();
    });
  };

  const initialise = (root = document) => {
    initialiseDirectory(root);
    initialiseCategoryBrowsers(root);
  };

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => initialise(), 150);
  });
})();
